export default "__VITE_ASSET__BahA4n0z__"